import React, { Fragment, useCallback, } from "react";
import { v4 as uuidv4 } from "uuid";
import { useFormContext } from "../Form";
import { observer } from "mobx-react-lite";
import { Checkbox as BSCheckbox } from "react-bootstrap";
import { ensureObservableValue } from "../withFormWrapper";
import { StaticMultipleValues } from "../StaticInput";
import { useSelectionAreaClasses } from "../styling/SelectionArea.styles";
import { classNames } from "../utils/classNames";
import { useCheckboxGroupClasses } from "./CheckboxGroup.styles";
import { useUtilityStyles } from "../hooks/useUtilityStyles";
var RawCheckboxGroup = observer(function (_a) {
    var children = _a.children, label = _a.label, options = _a.options, onChange = _a.onChange, name = _a.name, disabled = _a.disabled, staticFormatter = _a.staticFormatter, id = _a.id, dataId = _a.dataId, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, selectionDirection = _a.selectionDirection, styleOptions = _a.styleOptions;
    var labelId = id || uuidv4();
    var _b = useFormContext(), values = _b.values, formDisabled = _b.formDisabled, isStatic = _b.isStatic;
    if (name) {
        ensureObservableValue(values, name);
        if (!values.get(name)) {
            values.set(name, []);
        }
    }
    var value = values.get(name);
    var handleChange = useCallback(function (e, option) {
        var mappedExistingValues = value.map(function (v) { return v; });
        var index = value.indexOf(option);
        var checked = e.target.checked;
        if (checked && index === -1) {
            value.push(option);
        }
        else if (!checked && index !== -1) {
            value.splice(index, 1);
        }
        if (onChange) {
            onChange(value, mappedExistingValues);
        }
        values.set(name, value);
    }, [value, onChange, values, name]);
    if (isStatic && name && options) {
        var multiple = true;
        return (React.createElement(StaticMultipleValues, { name: name, label: label, staticFormatter: staticFormatter, options: options, multiple: multiple, dataId: dataId, dataTestId: dataTestId, dataLabel: dataLabel }));
    }
    return (React.createElement(Container, { styleOptions: styleOptions, dataId: dataId, labelId: labelId, dataTestId: dataTestId },
        React.createElement(Label, { label: label, labelId: labelId }),
        children && !options && children,
        !selectionDirection && options && (React.createElement(CheckboxStandard, { options: options, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId, value: value, disabled: formDisabled || disabled, handleChange: handleChange })),
        selectionDirection && options && (React.createElement(Group, { selectionDirection: selectionDirection }, options === null || options === void 0 ? void 0 : options.map(function (option, i) {
            var checked = value.indexOf(option.value) !== -1;
            var optionDisabled = formDisabled || disabled || option.disabled;
            return (React.createElement(SelectionArea, { checked: checked, disabled: optionDisabled, key: option.value, last: i + 1 === options.length, first: i === 0, label: option.label },
                React.createElement(Checkbox, { option: option, value: value, disabled: optionDisabled, onChange: handleChange, checked: checked })));
        })))));
});
var CheckboxStandard = observer(function (_a) {
    var options = _a.options, dataId = _a.dataId, dataTestId = _a.dataTestId, dataLabel = _a.dataLabel, value = _a.value, disabled = _a.disabled, handleChange = _a.handleChange;
    return (React.createElement(Fragment, null, options === null || options === void 0 ? void 0 : options.map(function (option) {
        return (React.createElement(BSCheckbox, { "data-id": dataId ? "".concat(dataId, "-").concat(option.value) : undefined, "data-testid": dataTestId ? "".concat(dataTestId, "-").concat(option.value) : undefined, "data-label": dataLabel ? "".concat(dataLabel, " ").concat(option.value) : undefined, key: option.value, name: option.value, checked: value.indexOf(option.value) !== -1, onChange: function (e) { return handleChange(e, option.value); }, disabled: disabled || option.disabled, "aria-labelledby": "label-".concat(option.value) },
            React.createElement("span", { id: "label-".concat(option.value) }, option.label)));
    })));
});
var Checkbox = function (_a) {
    var option = _a.option, disabled = _a.disabled, onChange = _a.onChange, checked = _a.checked;
    var classes = useSelectionAreaClasses({});
    var input = useCheckboxGroupClasses().input;
    return (React.createElement("label", { className: classNames(classes.selectionLabel, disabled ? classes.selectionLabelDisabled : undefined) },
        React.createElement("span", { className: classes.contentBlock }, option.label),
        React.createElement("input", { name: option.value, disabled: disabled, checked: checked, type: "checkbox", onChange: function (e) { return onChange(e, option.value); }, className: input })));
};
var Label = function (props) { return (React.createElement("span", { className: "form-control-static-label", id: (props === null || props === void 0 ? void 0 : props.labelId) ? "title-".concat(props === null || props === void 0 ? void 0 : props.labelId) : undefined }, props === null || props === void 0 ? void 0 : props.label)); };
var Container = function (props) {
    var classes = useUtilityStyles(props === null || props === void 0 ? void 0 : props.styleOptions);
    return (React.createElement("div", { "data-id": props === null || props === void 0 ? void 0 : props.dataId, "data-testid": props === null || props === void 0 ? void 0 : props.dataTestId, className: classNames("checkbox-group", classes.utilities), role: "group", "aria-labelledby": (props === null || props === void 0 ? void 0 : props.labelId) ? "title-".concat(props === null || props === void 0 ? void 0 : props.labelId) : undefined }, props === null || props === void 0 ? void 0 : props.children));
};
var Group = function (props) {
    var classes = useSelectionAreaClasses({});
    return (React.createElement("div", { className: classes.selectionAreaGroup, "data-hook": "selection-area-group" }, props === null || props === void 0 ? void 0 : props.children));
};
var SelectionArea = observer(function (props) {
    var checked = props.checked, disabled = props.disabled;
    var _a = useSelectionAreaClasses({
        last: props === null || props === void 0 ? void 0 : props.last,
        first: props === null || props === void 0 ? void 0 : props.first,
    }), selectionArea = _a.selectionArea, selectionAreaChecked = _a.selectionAreaChecked, selectionAreaDisabled = _a.selectionAreaDisabled, selectionAreaCheckedDisabled = _a.selectionAreaCheckedDisabled;
    return (React.createElement("div", { "data-checked": checked ? "true" : "false", "data-disabled": disabled ? "true" : "false", "data-label": props === null || props === void 0 ? void 0 : props.label, className: classNames(selectionArea, checked ? selectionAreaChecked : undefined, disabled ? selectionAreaDisabled : undefined, checked && disabled ? selectionAreaCheckedDisabled : undefined) }, props === null || props === void 0 ? void 0 : props.children));
});
export var CheckboxGroup = Object.assign(RawCheckboxGroup, {
    SelectionArea: SelectionArea,
    Group: Group,
    Checkbox: Checkbox,
    Container: Container,
    Label: Label,
});
